import { useEffect, useState } from 'react';
import { Alert, Button, Card, Space, Spin } from 'antd';
import { Link, useParams } from 'react-router-dom';
import E2ERun from '../../../domain/models/E2ERun';
import getE2ERun, { GetE2ERunPayload } from '../../../domain/use_cases/e2e/getE2ERun';
import E2ERunOverview from './E2ERunOverview';
import E2ESuiteResults from './E2ESuiteResults';
import useE2ERefresh from './useE2ERefresh';
import { E2E_RESULTS_PAGE_PATH, E2E_RESULTS_PAGE_TITLE } from './E2EResultsPage';
import PageScaffold from '../../components/PageScaffold';
import {
  VOIP_CALLS_PAGE_PATH,
  VOIP_CALLS_PAGE_TITLE,
} from '../leedflow/VoipCallsPage/VoipCallsPage';

export default function E2EResultDetailPage() {
  const { runKey = '' } = useParams();
  const [state, setState] = useState<{ runKey: string; run: E2ERun | null; error: string }>({
    runKey: '',
    run: null,
    error: '',
  });
  const run = state.runKey === runKey ? state.run : null;
  const error = state.runKey === runKey ? state.error : '';
  const [selection, setSelection] = useState<{ runKey: string; attempt?: number }>({ runKey: '' });
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let cancelled = false;
    getE2ERun(new GetE2ERunPayload(runKey))
      .then((value) => {
        if (!cancelled) setState({ runKey, run: value, error: '' });
      })
      .catch((error) => {
        if (!cancelled)
          setState({ runKey, run: null, error: error.message ?? 'Chargement impossible' });
      });
    return () => {
      cancelled = true;
    };
  }, [runKey, refresh]);
  const active = run ? run.active : false;
  useE2ERefresh(active, refresh, setRefresh);
  const attempt = run?.attempts.find(
    (a) =>
      a.runAttempt ===
      (selection.runKey === runKey ? selection.attempt ?? run.latestAttempt : run.latestAttempt)
  );
  const title = `Run E2E ${run ? `#${run.runId}` : ''}`;
  return (
    <PageScaffold
      title={title}
      breadcrumbItems={[
        { title: VOIP_CALLS_PAGE_TITLE, target: VOIP_CALLS_PAGE_PATH },
        { title: E2E_RESULTS_PAGE_TITLE, target: E2E_RESULTS_PAGE_PATH },
        { title },
      ]}
    >
      <Card
        title={title}
        extra={
          <Space>
            <Link to={E2E_RESULTS_PAGE_PATH}>Liste</Link>
            <Button onClick={() => setRefresh((v) => v + 1)}>Actualiser</Button>
          </Space>
        }
      >
        {error && <Alert message={error} type="error" showIcon />}
        {!run && !error && <Spin />}
        {run && attempt && (
          <>
            <E2ERunOverview
              run={run}
              attempt={attempt}
              onSelect={(value) => setSelection({ runKey, attempt: value })}
            />
            <E2ESuiteResults runKey={runKey} attempt={attempt} />
          </>
        )}
      </Card>
    </PageScaffold>
  );
}
